import { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { liveHubs } from '../data/hubs.js';

export default function HubViewer() {
  const { slug } = useParams();
  const hub = liveHubs.find((h) => h.id === slug);

  useEffect(() => {
    if (hub) {
      window.location.replace(hub.dir);
    }
  }, [hub]);

  if (!hub) {
    return <Navigate to="/" replace />;
  }

  return (
    <div style={{ padding: '4rem 2rem', textAlign: 'center' }}>
      <p className="eyebrow" style={{ marginBottom: '.75rem' }}>Loading hub</p>
      <p style={{ color: 'var(--black)', fontWeight: 600 }}>
        {hub.code} &middot; {hub.title}
      </p>
    </div>
  );
}